import { useNavigate } from 'react-router-dom';
import { useFetcher } from '../hooks/useFetcher';
import logo from '../assets/logo/icon.png';
import { ReactComponent as ShoppingCart } from '../assets/icons/basket-shopping-simple.svg';
import { ReactComponent as User } from '../assets/icons/user.svg';
import Search from './SearchInput';
import Carousel from './CategoriesCarousel';
import '../styles/Header.scss';
import HamburgerMenu from './HamburgerMenu';
import { useState,useEffect } from 'react';

const Header = ({ userData }) => {
  const navigate = useNavigate();
  const[cartValue,setCartValue]=useState(0);
  const [data] = useFetcher('home/cats');
  let newvalue=0;
  const onClick = () => {
    if (userData?.data?.id) {
      navigate('/panel');
    } else {
      navigate('/register');
    }
  };

  

  useEffect(()=>{
    let counter=0;
    if (localStorage.getItem('products') )
    JSON.parse(localStorage.getItem('products')).map(()=>{
      counter++;
    });
    setCartValue(counter);
  },[localStorage.getItem('products')])

  return (
    <header className='header flex flex-col justify-between gap-1 px-9 py-3 w-full h-24 bg-red-600 z-30'>
      <div className='flex flex-row justify-between my-auto'>
        <div className='w-14 flex justify-between items-start'>
          <div className='w-5 h-5 mb-2 cursor-pointer'>
            <User className='w-7 h-7' onClick={onClick} />
          </div>
          <div className='w-7 h-7 shopping-cart cursor-pointer'>
            <ShoppingCart
              className='w-7 h-7 icon-number'
              onClick={() => navigate('/cart')}
            />
            <span className="cart-number">{cartValue}</span>
          </div>
        </div>
        <Search styles='w-1/2 hidden md:flex' />
        <div
          className='flex flex-row justify-center gap-2 text-white'
          onClick={() => navigate('/')}>
          <span className='cursor-pointer'>همراهایپر</span>
          <img src={logo} alt='' className='w-8 h-8 cursor-pointer' />
        </div>
      </div>
      <div className=' flex justify-between items-center'>
        <Search styles='w-4/5 flex md:hidden' />
        <HamburgerMenu items={data}/>
      </div>
      <div className='text-white hidden md:block'>
        {data && <Carousel data={data} />}
      </div>
    </header>
  );
};

export default Header;
